module.exports = __webpack_public_path__ + "img/area_B.8cc4b78d.png";